"use strict"

import React, {useState} from "react"
import {observer} from "mobx-react"
import ReCAPTCHA from "react-google-recaptcha"
import MobxReactForm from "mobx-react-form"
import config from "../../global/config/settings"
import validatorjs from "validatorjs"
import dvr from "mobx-react-form/lib/validators/DVR"
import {injectIntl} from "react-intl"
import {Container, Grid, Typography, Link, Box} from "@material-ui/core"

import XsInput from "../../global/ui/xsInput/xsInput"
import XsNumberInput from "../../global/ui/xsInput/xsNumberInput"
import XsButton from "../../global/ui/xsButton/xsButton"
// import XsCheckbox from "../../global/ui/xsCheckbox/xsCheckbox"

import LoginStore from "./loginStore"
import GlobalStore from "../../global/store/GlobalStore"
import {isEmailValid} from "../../global/helpers/functions"
import XsPublicHeader from "../../global/ui/xsHeader/xsPublicHeader"
import XsCheckbox from "../../global/ui/xsCheckbox/xsCheckbox"
import ReactTooltip from "react-tooltip"
import XsAutocomplete from "../../global/ui/xsInput/xsAutocomplete"
import api from "../../global/actions/api"

function Register() {
	const hooks = {
		onSubmit(form) {
			const {email, company_name, company_identifier} = form.values()

			if (isEmpty(email) || isEmpty(company_name) || isEmpty(company_identifier) || !isEmailValid(email)) {
				GlobalStore.setNotificationMessage("Vyplnte všetky polia!", "", "warning")
				form.invalidate()
			}
		},
		onSuccess(form) {
			LoginStore.hanldeRegistration(form)
		},
		onError() {}
	}

	const [form] = useState(
		new MobxReactForm(
			{
				fields: {
					rpo_search: {label: "Vyhľadať podľa IČO alebo názvu subjektu", rules: "required"},
					isWithoutRpo: {label: "IČO a názov subjektu zadám ručne", type: "checkbox"},
					email: {label: "Prihlasovacie meno / email", rules: "required"},
					company_name: {label: "Obchodné meno / žiadateľ", rules: "required"},
					company_identifier: {label: "IČO", rules: "required|between:8,8"},
					personal_data: {
						label: "Beriem na vedomie spracúvanie poskytnutých osobných údajov",
						rules: "",
						type: "checkbox",
						value: false
					},
					communication_method: {
						label:
							"Žiadam, aby všetka komunikácia ohľadom žiadosti prebiehala elektronickou formou prostredníctvom schránky na portáli slovensko.sk. V prípade nezaškrtnutia tejto voľby bude komunikácia prebiehať listovou formou.",
						type: "checkbox",
						value: false
					},
					rpo_city: {},
					rpo_house_number: {},
					rpo_street: {},
					rpo_zip: {},
					rpo_legal_form: {}
				}
			},
			{plugins: {dvr: dvr(validatorjs)}, hooks}
		)
	)

	return (
		<React.Fragment>
			<XsPublicHeader />
			<Container maxWidth="lg" style={{marginTop: 96}}>
				<Grid container justify="center">
					<Grid item xs={12} md={7}>
						<Grid container direction="column" justify="center">
							<Grid container direction="column" spacing={3}>
								<Grid item className="textCenter">
									<Typography variant="h3">Registrácia žiadateľa</Typography>
								</Grid>
								<Grid item>
									<Box p={2}>
										<Grid item container direction="column" spacing={1}>
											<Grid item container spacing={1}>
												<Grid item xs={12} md={6}>
													<XsAutocomplete
														// "https://isee.siea.sk/csp/rmee-ext-public/data-lake/rpo"
														field={form.$("rpo_search")}
														minLengthForSearch="3"
														autoFocus={true}
														api={api.rpoSearch}
														inputRenderer={(obj) => `${obj.name} ${obj.identifier}`}
														saveValue={(obj) => obj.identifier}
														searchFilter={"search"}
														rowCountFull={10}
														disabled={form.$("isWithoutRpo").value === true}
														postAction={(value) => {
															form.$("company_name").value = value.name
															form.$("company_identifier").value = value.identifier
															form.$("rpo_city").value = value.city_id
															form.$("rpo_house_number").value = value.house_number
															form.$("rpo_street").value = value.street_plain
															form.$("rpo_zip").value = value.zip_plain
															form.$("rpo_legal_form").value = value.legal_form_name_ext
														}}
													/>
												</Grid>
												<Grid item xs={12} md={6}>
													<XsCheckbox
														field={form.$("isWithoutRpo")}
														onChange={() => {
															if (form.$("isWithoutRpo").value === true) {
																form.$("rpo_search").value = ""
																form.$("rpo_search").set("rules", "")
																form.$("company_name").value = ""
																form.$("company_identifier").value = ""
																form.$("rpo_city").value = ""
																form.$("rpo_house_number").value = ""
																form.$("rpo_street").value = ""
																form.$("rpo_zip").value = ""
																form.$("rpo_legal_form").value = ""
															} else {
																form.$("rpo_search").value = ""
																form.$("rpo_search").set("rules", "required")
															}
														}}
													/>
												</Grid>
												{form.$("isWithoutRpo").value === true && (
													<React.Fragment>
														<Grid item xs={12} md={6}>
															<XsInput field={form.$("company_name")} submitAction={(e) => form.onSubmit(e)} />
														</Grid>
														<Grid item xs={12} md={6} data-tip data-for="company_identifier">
															{/* <XsInput field={form.$("company_identifier")} submitAction={(e) => form.onSubmit(e)} /> */}
															<XsNumberInput field={form.$("company_identifier")} step={"1"} min={"1"} />
															<ReactTooltip className="custom-tooltip-line-height" id="company_identifier">
																Skontrolujte prosím správnosť Vaších údajov, už ich nebudete môcť zmeniť.
															</ReactTooltip>
														</Grid>
													</React.Fragment>
												)}
											</Grid>
											<Grid item container spacing={4}>
												<Grid item xs={12} className="mt-4">
													Obchodné meno je potrebné vyplniť v súlade s Obchodným registrom / Živnostenským registrom
													resp. iným registrom, v ktorom je osoba zapísaná. Uvedený údaj už nie je možné dodatočne
													meniť.
												</Grid>
												<Grid item xs={12} md={7}>
													<XsInput
														field={form.$("email")}
														submitAction={(e) => form.onSubmit(e)}
														regex={(val) => isEmailValid(val)}
													/>
												</Grid>
											</Grid>
											<Grid item container spacing={2} className="mt-4">
												<Grid item xs={12}>
													<Typography variant="body1" className="bold">
														Spôsob komunikácie
													</Typography>
												</Grid>
												<Grid item xs={12}>
													<XsCheckbox field={form.$("communication_method")} />
												</Grid>
											</Grid>
											<Grid item container spacing={1} className="mt-4">
												<Grid item>
													<Typography variant="body1">Spracúvanie osobných údajov:</Typography>
												</Grid>
												<Grid item>
													<Link
														variant="body1"
														className="pointer"
														underline="always"
														onClick={() => window.open("https://www.siea.sk/o-siea/ochrana-osobnych-udajov/", "_blank")}
													>
														https://www.siea.sk/o-siea/ochrana-osobnych-udajov/
													</Link>
												</Grid>
											</Grid>
											<Grid item>
												<XsCheckbox field={form.$("personal_data")} />
											</Grid>
											{GlobalStore.enabledRecaptchaV2 && (
												<Grid item>
													<ReCAPTCHA
														sitekey={config.SITE_KEY_V2 || ""}
														onChange={(token) => {
															GlobalStore.tokenRecaptchaV2 = token
														}}
													/>
												</Grid>
											)}
											<Grid item container justify="flex-end">
												<Grid item>
													<XsButton
														disabled={!form.$("personal_data").value}
														text="Registrovať sa"
														fullWidth={false}
														onClick={form.onSubmit}
													/>
												</Grid>
											</Grid>
										</Grid>
									</Box>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Container>
		</React.Fragment>
	)
}

export default injectIntl(observer(Register))

